import { css } from '@emotion/css'

import { borderRadius, fontSize, fontWeight, spacing } from '../../../../styles'
import { shorthandHelper } from '../../../../styles/helpers'
import getThemeColors, { colors } from '../../../../themes'

const xxLarge = 40

const styles = {
  counter: css({
    borderRadius: borderRadius.default,
    backgroundColor: colors.porcelain,
    padding: shorthandHelper([spacing.small, spacing.default, spacing.default, spacing.default]),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.default,
  }),

  count: css({
    fontSize: xxLarge,
    fontWeight: fontWeight.bold,
  }),

  current: css({
    color: colors.cornflowerBlue,
  }),

  empty: css({
    opacity: 0.5,
  }),
}

export default styles

export const currentTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    color: themed.base,
  })
}
